import { authRequest } from './index.js'

function packageParser(responseData){
  const parsedData = responseData.data.map(item => {
    const packageType = item.attributes.name;
    const id = item.id;
    const options = {};
  
    // Find the related option_meta data for the current item
    const optionMetaData = item.relationships.option_meta.data.map(option => {
      const optionDetails = responseData.included.find(includedItem => includedItem.id === option.id);
  
      if (optionDetails) {
        options[optionDetails.attributes.key] = {id: optionDetails.id, value: optionDetails.attributes.value};
      }
  
      return optionDetails;
    });
  
    return { id, package_type: packageType, options };
  }); 
  return parsedData;
}

export async function get_package(){
  let data
  await authRequest.get(
    '/packages',
  )
  .then(function(result){
    let parser = packageParser(result.data)
    data = {result: parser, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_packages(){
  let data
  await authRequest.get(
    '/packages',
  )
  .then(function(result){
    let parser = packageParser(result.data)
    data = {result: parser, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_characteristics(package_id){
  let data
  await authRequest.get(
    'packages/' + package_id + '/characteristics/',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_trait(trait_id){
  let data
  await authRequest.get(
    'traits/' + trait_id,
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}